import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useAppSelector } from '../../store/hooks';
import { useAuth } from '../../hooks/useAuth';
import LoadingScreen from '../ui/LoadingScreen';
import { ROUTES } from '../../utils/constants';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  const authState = useAppSelector((state) => state.auth);
  const { isLoading: auth0IsLoading } = useAuth0();
  const contextLoading = authState.isLoading;

  if (contextLoading || auth0IsLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.SIGNIN} replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;

